import { useState } from "react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Stats } from "@/components/Stats";
import { Products } from "@/components/Products";
import { Levels } from "@/components/Levels";
import { TerritoryMap } from "@/components/TerritoryMap";
import { Developer } from "@/components/Developer";
import { Manifesto } from "@/components/Manifesto";
import { Banner } from "@/components/Banner";
import { Footer } from "@/components/Footer";
import { ApplicationForm } from "@/components/ApplicationForm";

export default function Landing() {
  const [open, setOpen] = useState(false);
  const apply = () => setOpen(true);

  return (
    <main className="bg-oed-base">
      <Nav onApply={apply} />
      <Hero onApply={apply} />
      <EditorialMarquee />
      <Stats />
      <Products />
      <Levels />
      <TerritoryMap />
      <Developer />
      <Manifesto />
      <Banner onApply={apply} />
      <Footer onApply={apply} />
      <ApplicationForm open={open} onClose={() => setOpen(false)} />
    </main>
  );
}
